import CoreApiClient from './core-api-client';
import { GeocodeResult } from '../models/geocoder';
import { ServerError, ServerErrorMessages } from '../utils/server-error-utils';

export default class GeocoderService {

  static async search(query: string, location: string): Promise<GeocodeResult[]> {
    return CoreApiClient.get('places/search', {
      params: {
        query,
        location,
      }
    })
      .then(resp => {
        return resp.data?.response?.items;
      })
      .catch((error: Error) => {
        let errorMessage = ServerErrorMessages[error.message];
        if (!errorMessage) {
          errorMessage = ServerErrorMessages[ServerError.UnexpectedError];
        }

        throw new Error(errorMessage);
      });
  }
}
